import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import { normalizedData } from "@utils";
import Seo from "@components/seo";
import Layout from "@layout";
import Header from "@layout/header/layout-01";
import Footer from "@layout/footer/layout-01";
import PageHeader from "@containers/page-header/layout-01";
import ContactArea from "@containers/contact/layout-03";
import "@components/forms/consult-form-02/public-notice.css";
import PdfUrl from "@assets/images/2024浙江省科学技术进步奖公示信息表.pdf";

const PublicNoticePage = ({ pageContext, location, data }) => {
    const content = normalizedData(data?.page?.content || []);
    const globalContent = normalizedData(data?.allGeneral.nodes || []);

    return (
        <Layout location={location}>
            <Seo title="公示" />
            <Header
                data={{
                    ...globalContent["header"],
                    ...globalContent["menu"],
                }}
            />
            <main className="site-wrapper-reveal">
                {/* Public Notice Content Section */}
                <section
                    className="about-section  padding-bottom-100"
                    style={{ margin: "100px 0" }}
                >
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-10 mx-auto">
                                <div className="about-content">
                                    <div className="section-title text-center">
                                        <h2 className="h3">
                                            关于拟提名2024年度浙江省科学技术奖励成果的公示
                                        </h2>
                                    </div>

                                    <div className="notice-content">
                                        <div className="notice-text">
                                            <p
                                                style={{
                                                    fontSize: "18px",
                                                    lineHeight: "1.8",
                                                    color: "#333",
                                                    fontWeight: "400",
                                                    textAlign: "justify",
                                                    letterSpacing: "0.5px",
                                                    textIndent: "2em",
                                                }}
                                            >
                                                根据《浙江省科学技术奖励办法》和《浙江省科学技术厅关于开展2024年度浙江省科学技术奖提名工作的通知》的规定要求，现开始对我单位拟申报的省科学技术奖励成果予以公示(见附件),公示期为7天(即自2025年9月12日至2025年9月18日)
                                            </p>
                                            <p
                                                style={{
                                                    fontSize: "18px",
                                                    lineHeight: "1.8",
                                                    color: "#333",
                                                    fontWeight: "400",
                                                    textAlign: "justify",
                                                    marginBottom: "10px",
                                                    letterSpacing: "0.5px",
                                                    textIndent: "2em",
                                                }}
                                            >
                                                在公示期内如有异议，可以来电或来信方式反映。凡匿名异议、超出期限异议的，不予受理。
                                            </p>
                                            <p
                                                style={{
                                                    fontSize: "18px",
                                                    lineHeight: "1.8",
                                                    color: "#333",
                                                    fontWeight: "400",
                                                    textAlign: "justify",
                                                    marginBottom: "10px",
                                                    letterSpacing: "0.5px",
                                                    textIndent: "2em",
                                                }}
                                            >
                                                联系人：吴丹妮
                                            </p>
                                            <p
                                                style={{
                                                    fontSize: "18px",
                                                    lineHeight: "1.8",
                                                    color: "#333",
                                                    fontWeight: "400",
                                                    textAlign: "justify",
                                                    marginBottom: "10px",
                                                    letterSpacing: "0.5px",
                                                    textIndent: "2em",
                                                }}
                                            >
                                                联系方式：15325843270
                                            </p>
                                        </div>

                                        <div className="attachment-section">
                                            <h4>相关附件</h4>
                                            <div className="attachment-list">
                                                <div className="attachment-item">
                                                    <div className="attachment-info">
                                                        <i className="far fa-file-pdf"></i>
                                                        <div className="file-details">
                                                            <span className="file-name">
                                                                2024浙江省科学技术进步奖公示信息表.pdf
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <a
                                                        href={PdfUrl}
                                                        className="btn btn-primary btn-sm"
                                                        download
                                                    >
                                                        下载
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer data={{ ...data.site.siteMetadata }} />
        </Layout>
    );
};

export const query = graphql`
    query PublicNoticePageQuery {
        allGeneral {
            nodes {
                section
                ...HeaderOne
            }
        }
        site {
            ...Site
        }
        page(title: { eq: "public-notice" }, pageType: { eq: "innerpage" }) {
            content {
                ...PageContent
            }
        }
    }
`;

PublicNoticePage.propTypes = {
    pageContext: PropTypes.shape({}),
    location: PropTypes.shape({}),
    data: PropTypes.shape({
        allGeneral: PropTypes.shape({
            nodes: PropTypes.arrayOf(PropTypes.shape({})),
        }),
        site: PropTypes.shape({
            siteMetadata: PropTypes.shape({
                contact: PropTypes.shape({}),
            }),
        }),
        page: PropTypes.shape({
            content: PropTypes.arrayOf(PropTypes.shape({})),
        }),
    }),
};

export default PublicNoticePage;
